'use strict';

((createApp, fetch, location, URLSearchParams) => {
  createApp({
    data () {
      return {
        page: 1,
        pageSize: 25,
        searchText: '',
        biomarkers: [],
        biomarkersInit: [],
        selectedItem: null
      };
    },
    methods: {
      async fetchJson (url) {
        return fetch(url).then((response) => response.json());
      },
      search () {
        this.fetchJson(`/api/biomarkers?search=${this.searchText}`)
          .then((biomarkers) => {
            this.biomarkers = biomarkers;
          });
      },
      setHash (key, value) {
        const hashParams = new URLSearchParams(window.location.hash.replace('#', '?'));
        hashParams.set(key, value);
        location.hash = hashParams.toString().replace('?', '#');
      },
      readHash (key) {
        if (!location.hash) {
          this.selectedItem = null;
          return;
        }
        const hashParams = new URLSearchParams(window.location.hash.replace('#', '?'));
        return hashParams.get(key);
      },
      selectItem (item) {
        this.selectedItem = item;
        this.setHash('biomarker', item.name);
      }
    },
    watch: {
      searchText (newValue) {
        if (newValue?.length > 2)
          this.search();
        else
          this.biomarkers = [...this.biomarkersInit];
      }
    },
    async created () {
      this.biomarkersInit = await this.fetchJson('/api/biomarkers');
      this.biomarkers = [...this.biomarkersInit];
      const s = this.readHash('biomarker');
      if (s)
        this.selectedItem = this.biomarkers.find(i => i.name === s);
      else
        this.selectedItem = this.biomarkers[0];
      window.scope = this;
    }
  }).mount('#app');
})(window.Vue.createApp, window.fetch, window.location, window.URLSearchParams);
